<ng-container [ngSwitch]="type">

    <ion-card color="danger" *ngSwitchCase="'exchange'" class="ion-no-margin ion-margin-top ion-margin-bottom">
        <ion-card-header>
            <ion-card-subtitle i18n>Inserisci la tua proposta di scambio</ion-card-subtitle>
        </ion-card-header>
    </ion-card>
    <ion-card color="success" *ngSwitchCase="'formation'" class="ion-no-margin ion-margin-top ion-margin-bottom">
        <ion-card-header>
            <ion-card-subtitle i18n>Inserisci il tuo dubbio di formazione</ion-card-subtitle>
        </ion-card-header>
    </ion-card>
    <ion-card color="warning" *ngSwitchCase="'purchase'" class="ion-no-margin ion-margin-top ion-margin-bottom">
        <ion-card-header>
            <ion-card-subtitle i18n>Inserisci il tuo dubbio di acquisto</ion-card-subtitle>
        </ion-card-header>
    </ion-card>

    <ion-card color="primary" class="ion-no-margin ion-no-padding">
        <ion-card-content>
            <!-- Exchange  -->
            <ion-grid *ngSwitchCase="'exchange'">

                <ion-row *ngIf="!!improvedCatalogItems['exchange']">
                    <ion-col size="6" class="ion-align-items-center ion-align-self-center ion-text-center">
                        <ion-button color="secondary" expand="block" (click)="select('1x1')" class="matrix-item" [ngClass]="{active: true}">
                            <ion-text>1 X 1</ion-text>
                        </ion-button>
                    </ion-col>
                    <ion-col size="6" class="ion-align-items-center ion-align-self-center ion-text-center" *ngFor="let item of improvedCatalogItems['exchange']">
                        <ion-button color="secondary" expand="block" (click)="select(item.item_detail)" class="matrix-item" [ngClass]="{active: item.isPurchased}">
                            <ion-text>{{ item.item_description }}</ion-text>
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>

            <!-- Formation  -->
            <ion-grid *ngSwitchCase="'formation'">
                <ion-row *ngIf="!!improvedCatalogItems['formation']">
                    <ion-col size="6" class="ion-align-items-center ion-align-self-center ion-text-center">
                        <ion-button color="secondary" expand="block" (click)="select('1:2')" class="matrix-item" [ngClass]="{active: true}">
                            <ion-text>1 <span i18n>SU</span> 2</ion-text>
                        </ion-button>
                    </ion-col>
                    <ion-col size="6" class="ion-align-items-center ion-align-self-center ion-text-center" *ngFor="let item of improvedCatalogItems['formation']">
                        <ion-button color="secondary" expand="block" (click)="select(item.item_detail)" class="matrix-item" [ngClass]="{active: item.isPurchased}">
                            <ion-text>{{ item.item_description }}</ion-text>
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>

            <!-- Purchase  -->
            <ion-grid *ngSwitchCase="'purchase'">
                <ion-row *ngIf="!!improvedCatalogItems['purchase']">
                    <ion-col size="6" class="ion-align-items-center ion-align-self-center ion-text-center">
                        <ion-button color="secondary" expand="block" (click)="select('1:2')" class="matrix-item" [ngClass]="{active: true}">
                            <ion-text>1 <span i18n>SU</span> 2</ion-text>
                        </ion-button>
                    </ion-col>
                    <ion-col size="6" class="ion-align-items-center ion-align-self-center ion-text-center" *ngFor="let item of improvedCatalogItems['purchase']">
                        <ion-button color="secondary" expand="block" (click)="select(item.item_detail)" class="matrix-item" [ngClass]="{active: item.isPurchased}">
                            <ion-text>{{ item.item_description }}</ion-text>
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>

        </ion-card-content>
    </ion-card>
</ng-container>
